<template>
    <div class="content">
        <div class="content-head">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="ERP订单号">
                    <el-input  autocomplete="on" name="ERPOrderSN"  v-model="params.ERPOrderSN" placeholder="请输入" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="工程名称">
                    <el-input autocomplete="on" name="ProjectName"  v-model="params.ProjectName" placeholder="请输入" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="办事处编码">
                    <el-input autocomplete="on" name="BranceOfficeCode"  v-model="params.BranceOfficeCode" placeholder="请输入" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="业务员编码">
                    <el-input autocomplete="on" name="BranceOfficeMemerCode"  v-model="params.BranceOfficeMemerCode" placeholder="请输入" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="统计日期" v-if="isFiltration">
                    <el-date-picker v-model="params.ValidStartDate" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                    <span style="margin: 0 5px">至</span>
                    <el-date-picker v-model="params.ValidEndDate" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>

                <el-form-item label="对冲状态" v-if="isFiltration">
                    <el-select v-model="params.ValidStatus" placeholder="请选择" class="el-select-medium">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="数据类型" v-if="isFiltration">
                    <el-select v-model="params.DataType" placeholder="请选择" class="el-select-medium">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="getTableData(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh">重置</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="setFiltration" :icon="!isFiltration ? 'el-icon-arrow-down' : 'el-icon-arrow-up'">
                        {{ !isFiltration ? '展开' : '收起' }}
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title">
                业务划分统计结果列表
                <div>
                    <span style="margin-right: 10px" v-if="Resultinfo == '1'"><el-button plain @click="dialogVisible = true">重新计算</el-button></span>
                    <el-dropdown trigger="click">
                        <el-button type="primary">
                            导出
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <span @click="getExport()">导出查询信息</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <el-table  :row-class-name="tableRowClassName" @row-click="handleRowClick" :data="tableData" :height="maxheight" ref="multipleTable" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">

                <el-table-column prop="Result_ID" label="ID" width="80" align="center" fixed></el-table-column>
                <el-table-column prop="Result_ERPOrderSN" label="ERP订单号" width="150" align="center" fixed></el-table-column>
                <el-table-column prop="Result_OrderID" label="订单类型" align="center" width="150"></el-table-column>
                <el-table-column prop="Result_ProjectName" label="工程名称" align="left" show-overflow-tooltip width="200"></el-table-column>
                <el-table-column prop="Result_OfficeCode" label="办事处编码" width="150" align="center"></el-table-column>
                <el-table-column prop="Result_OfficeMemberCode" label="业务员编码" width="150" align="center"></el-table-column>
                <el-table-column prop="Result_TotalDeliveryAmount" label="发货金额" width="120" align="center">
                    <template slot-scope="scope">
                        <span>￥{{ scope.row.Result_TotalDeliveryAmount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Result_TotalReceivedAmount" label="回款金额" width="120" align="center">
                    <template slot-scope="scope">
                        <span>￥{{ scope.row.Result_TotalReceivedAmount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Result_Rate" label="分配比例%" width="120" align="center"></el-table-column>
                <el-table-column prop="Result_TotalDate" label="统计日期" width="120" align="center"></el-table-column>
                <el-table-column prop="DistributeMain_IsInvalidName" label="对冲状态" width="120" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.Result_ValidStatus == 0 ? '正常' : scope.row.Result_ValidStatus == 1 ? '对冲' : '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="DistributeMain_AddTime" label="数据类型" width="150" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.Result_DataType == 0 ? '原始数据' : scope.row.Result_DataType == 1 ? '业绩划分数据' : '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Result_ERPDate" label="业务日期" width="130" align="center"></el-table-column>
                <el-table-column prop="Result_UpdateDate" label="修改时间" width="150" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.Result_UpdateDate | formatDates }}
                    </template>
                </el-table-column>
                <el-table-column prop="Result_Version" label="版本号" width="150" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="120" fixed="right">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="handleOpen(scope.row)">查看</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
        <el-dialog title="更新计算结果" :visible.sync="dialogVisible" width="375px" :before-close="handleClose" :close-on-click-modal="false">
            <el-form label-position="right" label-width="80px" :model="formLabelAlign">
                <el-form-item label="选择日期">
                    <el-date-picker v-model="formLabelAlign.name" type="date" placeholder="选择日期"></el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="handleClose">开始计算</el-button>
            </span>
        </el-dialog>
        <statisticsDetails :isdetailFlag="isdetailFlag" @handleClose="handleClose1" :id="id"></statisticsDetails>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import statisticsDetails from './components/statisticsDetails.vue';
import { formatDate, downloadFile } from '@/utils/utils.js';
import { myMixin } from '@/utils/mixin.js';
export default {
    name: 'statisticsPerformanceDivision',
    mixins: [myMixin],
    components: {
        Pagination,
        statisticsDetails
    },
    data() {
        return {
            id: 0,
            Resultinfo: '',
            isdetailFlag: false,
            loadingBtn: false,
            dialogVisible: false,
            formLabelAlign: {},
            params: {},
            tableData: [],
            options: [
                { value: 1, label: '正常' },
                { value: 2, label: '对冲' }
            ],
            options1: [
                { value: 1, label: '原始数据' },
                { value: 2, label: '业绩划分数据' }
            ]
        };
    },
    mounted() {
        this.onRefresh();
    },
    methods: {
        /*
        重置数据
      */
        onRefresh() {
            this.params = {
                ERPOrderSN: '',
                ProjectName: '',
                BranceOfficeCode: '',
                BranceOfficeMemerCode: '',
                ValidStartDate: '',
                ValidEndDate: '',
                ValidStatus: '',
                DataType: ''
            };
            this.formLabelAlign = {
                name: '',
                region: '',
                type: ''
            };
            this.Resultinfo = '';
            this.getTableData(true);
        },
        /*
          过滤数据
        */
        filteropt() {
            let params = { ...this.params };
            return { json: JSON.stringify(params), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        /*
        导出数据
        */
        getExport() {
            this.$newsApi.getOrdersPerformanceReslutExport2(this.filteropt()).then((res) => {
                if (res.data.Resultcode == 0) {
                    downloadFile(res.data.data, res.data.Resultinfo);
                }
            });
        },
        /*
        查询数据
        */
        getTableData(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi
                .getOrdersPerformanceResluts(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.tableData.map((item) => {
                            item.Result_TotalDate = formatDate(item.Result_TotalDate, true);
                            item.Result_ERPDate = formatDate(item.Result_ERPDate, true);
                            item.Result_UpdateDate = formatDate(item.Result_UpdateDate, true);
                        });
                        this.paginationOptions.total = res.data.RecordCount;
                        this.Resultinfo = res.data.Resultinfo;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getTableData();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getTableData();
        },
        handleClose() {
            this.dialogVisible = false;
        },
        handleClose1() {
            this.isdetailFlag = false;
        },
        handleOpen(row) {
            console.log(row);
            this.id = row.Result_ID;
            this.isdetailFlag = true;
        }
    }
};
</script>

<style lang="scss" scoped>
.content-head {
    padding: 15px 20px 5px 20px;
}
.el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
</style>